
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 16a8 8 0 10-8-8 8 8 0 008 8z","fill":"red"}}),_c('path',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","d":"M5 5l6 6M5 5l6 6M5 5l6 6M5 5l6 6M5 5l6 6m0-6l-6 6"}})])
          )
        }
      }
    